module.exports = __webpack_public_path__ + "static/media/menu-hamburguesa.017fe639.svg";